<script setup lang="ts">
import type { IWidgetApplications } from './types'
import { TabletSmartphone } from 'lucide-vue-next'

const props = withDefaults(defineProps<IWidgetApplications>(), {
  variant: 'white'
})
</script>

<template>
  <div class="space-y-4">
    <template v-for="application in props.applications" :key="application.id">
      <div class="flex items-start gap-4">
        <div
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-blue-50 to-blue-100 sm:h-16 sm:w-16"
        >
          <TabletSmartphone class="h-5 w-5 text-blue-600 sm:h-7 sm:w-7" />
        </div>

        <div class="flex-1 space-y-3">
          <div class="space-y-1">
            <Heading tag="h3" class="h5">{{ application.title }}</Heading>
            <Badge variant="gray">
              {{ application.application_type }}
            </Badge>
          </div>

          <Content v-if="application.description">
            <div v-html="application.description" />
          </Content>

          <div
            v-if="application.android_url || application.appstore_url"
            class="flex flex-wrap gap-2"
          >
            <NuxtLinkLocale
              v-if="application.android_url"
              :to="application.android_url"
              class="inline-block transition-transform hover:scale-105"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="$t('common.download_from_google_play')"
            >
              <i class="[&>svg]:h-10 [&>svg]:w-auto [&>svg]:max-w-[140px]"><UiIcon name="google-play" /></i>
            </NuxtLinkLocale>
            <NuxtLinkLocale
              v-if="application.appstore_url"
              :to="application.appstore_url"
              class="inline-block transition-transform hover:scale-105"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="$t('common.download_from_app_store')"
            >
              <i class="[&>svg]:h-10 [&>svg]:w-auto [&>svg]:max-w-[140px]"><UiIcon name="app-store" /></i>
            </NuxtLinkLocale>
          </div>
        </div>
      </div>

      <hr
        v-if="application !== props.applications[props.applications.length - 1]"
        class="border-gray-200"
      />
    </template>
  </div>
</template>
